import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, IconButton, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function ProductActions({ editTo, onDelete, disabled = false }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Tooltip title="Edit product">
                <span>
                    <IconButton
                        size="small"
                        component={RouterLink}
                        to={editTo}
                        disabled={disabled}
                        aria-label="Edit product"
                    >
                        <EditOutlinedIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Delete product">
                <span>
                    <IconButton
                        size="small"
                        color="error"
                        onClick={onDelete}
                        disabled={disabled}
                        aria-label="Delete product"
                    >
                        <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
}
